"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.videoBitrateOption = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
let videoBitrate = null;
const cliFlag = 'video-bitrate';
exports.videoBitrateOption = {
    name: 'Video Bitrate',
    cliFlag,
    description: () => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Specify the target bitrate for the generated video. The syntax for FFmpeg", "'", "s", (0, jsx_runtime_1.jsx)("code", { children: "-b:v" }), " parameter should be used. FFmpeg may encode the video in a way that will not result in the exact video bitrate specified. Example values: ", (0, jsx_runtime_1.jsx)("code", { children: "512K" }), " for 512 kbps, ", (0, jsx_runtime_1.jsx)("code", { children: "1M" }), " for 1 Mbps."] })),
    ssrName: 'videoBitrate',
    docLink: 'https://www.remotion.dev/docs/renderer/render-media#videobitrate',
    type: '',
    getValue: ({ commandLine }) => {
        if (commandLine[cliFlag] !== undefined) {
            return {
                source: 'cli',
                value: commandLine[cliFlag],
            };
        }
        if (videoBitrate !== null) {
            return {
                source: 'config',
                value: videoBitrate,
            };
        }
        return {
            source: 'default',
            value: null,
        };
    },
    setConfig: (bitrate) => {
        videoBitrate = bitrate;
    },
};
